export const PrimerPreferences = {
  MELTING_TEMP_DNA: 'MELTING_TEMP',
  MELTING_TEMP_RNA: 'MELTING_TEMP_RNA',
  SECONDARY_TEMP: 'secondary-temp',
  WIZARD: 'primer-wizard',
};

export const FindPrimersPreferences = {
  MIN_MELTING_TEMP: 'findprimers.MIN_MELTING_TEMP',
  MAX_MELTING_TEMP: 'findprimers.MAX_MELTING_TEMP',
  MAX_MISMATCHES: 'findprimers.MAX_MISMATCHES',
  MAX_TOTAL_MISMATCHES: 'findprimers.MAX_TOTAL_MISMATCHES',
  MIN_MATCHING_BASES: 'findprimers.MIN_MATCHING_BASES',
  EXACT_MATCH: 'findprimers.EXACT_MATCH',
  UNIQUE_MATCH: 'findprimers.UNIQUE_MATCH',
  RESULTS_SORT: 'findprimers.RESULTS_SORT',
};

export const RESULT_SORTS = {
  LOCATION: 'location',
  TEMPERATURE: 'temperature',
  NAME: 'name',
  STRAND_PLUS: 'strandPlus',
  STRAND_MINUS: 'strandMinus',
  PERCENT_MATCH: 'percentMatch',
};

// Used in FindPrimersResults as a sentinel value for the result sort dropdown. This value is never saved in
// preferences.
export const RESULT_SORT_STRAND_TOGGLE = 'strand';

export const MAX_PRIMER_NAME_LENGTH = 255; // Should be kept in sync with FolderItemMixin.MAX_NAME_LENGTH
